export let mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2, xn: 0.5, yn: 0.5 }
window.addEventListener('mousemove', e => {
  mouse = {
    x: e.clientX,
    y: e.clientY,
    xn: (range(e.clientX, 0, window.innerWidth, -1, 1)).toFixed(2),
    yn: (range(e.clientY, 0, window.innerHeight, -1, 1)).toFixed(2)
  }
})

export function range (val, inMin, inMax, outMin, outMax) {
  return ((val - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
}

export function lerp (start, end, amt) {
  return (1 - amt) * start + amt * end
}

export function toScreenPosition (obj, camera, renderer) {
  const { Vector3 } = require('three')
  var vector = new Vector3()

  var widthHalf = 0.5 * renderer.context.canvas.width
  var heightHalf = 0.5 * renderer.context.canvas.height

  obj.updateMatrixWorld()
  vector.setFromMatrixPosition(obj.matrixWorld)
  vector.project(camera)

  vector.x = vector.x * widthHalf + widthHalf
  vector.y = -(vector.y * heightHalf) + heightHalf

  return {
    x: vector.x,
    y: vector.y
  }
}

export class MultiLerp {
  constructor (keys, arrayOfArrays) {
    this.start = Math.min(...keys)
    this.end = Math.max(...keys)
    this.keys = keys

    this.evolutions = []
    arrayOfArrays[0].forEach((_, i) => {
      this.evolutions[i] = []
      arrayOfArrays.forEach(data => this.evolutions[i].push(data[i]))
    })

    this.evolutions = this.evolutions.map(timeline => timeline.map((value, i) => {
      const numTL = timeline.filter(val => typeof val === 'number')
      return typeof value !== 'number' ? numTL[numTL.length - 1] : value
    }))
  }

  at (time) {
    const start = Math.max(0, this.keys.filter(key => key < time).length - 1)
    const end = start + 1
    const prog = range(time, this.keys[start], this.keys[end], 0, 1)

    const value = this.evolutions.map(evol => lerp(evol[start], evol[end], prog))

    return value
  }
}
